export default {
	pay: {
		waitPay          : "等待支付",
		purchase         : "购买商品",
		totalAmount      : "总金额",
		otherMethods     : "其他支付方式",
		payAmount        : "付款金额",
		payMethod        : "付款方式",
		payTime          : "付款时间",
		complete         : "完成",
		successfulPayment: "成功支付",
		applePay         : "苹果支付",
		googlePay        : "谷歌支付",
		googlePay        : "谷歌支付"
	},
	language: {
		switchLanguage: "切换语言",
		return        : "返回"
	},
	order: {
		payOrder          : "支付订单",
		payAmount         : "支付金额",
		payType           : "支付方式",
		payStatus         : "支付状态",
		selectPayment     : "选择支付方式",
		copy              : "复制",
		expires           : "后失效",
		orderId           : "订单ID",
		orderDetail       : "订单详情",
		refresh           : "刷新",
		havePaid          : "我已支付",
		retry             : "重试",
		use               : "使用",
		problems          : "是否在支付中遇见问题?",
		otherOne1         : "通过ATM支付的方法",
		otherOne2         : "1.在失效前访问最近的ATM",
		otherOne3         : "2.通过ATM转账功能转账",
		otherOne4         : "3.核对上面的付款码并输入转账",
		otherOne5         : "4.根据金额支付",
		otherTwo1         : "通过在线支付的方法",
		otherTwo2         : "1.在失效前访问对应线上银行",
		otherTwo3         : "2.通过线上银行转账功能转账",
		otherTwo4         : "3.核对上面的付款码并输入该付款码",
		otherTwo5         : "4.根据金额支付",
		otherThree1       : "通过银行支付的方法",
		otherThree2       : "1.在失效前访问最近的银行",
		otherThree3       : "2.通知收银员付款",
		otherThree4       : "3.告诉或出示上面的付款码",
		otherThree5       : "4.根据金额支付",
		rechargeSuccessful: "充值成功",
		gold              : "金币",
		rewardCoins       : "奖励币",
		ovo               : "OVO支付",
		amountDue         : "需支付",
		changePayment     : "更改支付方式",
		proceedtoPay      : "前往支付",
		phoneNumber       : "电话号码",
		phoneNumber       : "手机号",
		phoneNumber2      : "请输入正确手机号",
		phoneNumber3      : "请输入手机号",
		orderForm1        : "订单已生成",
		orderForm2        : "请前往",
		orderForm3        : "完成支付"
	},
	// 充值
	recharge: {
		recharge             : "充值",
		coins                : "金币",
		bonus                : "奖励币",
		GoldCoinRechargeRules: "金币规则：",
		goldCoinsAreVirtual  :
      "金币是虚拟物品，不能退还。仅用于本产品解锁应用程序中的付费内容。",
		expiredDeletion         : "充值等价：1金币=1奖金。请注意，不支持充值退款。",
		expiredWillBeInvalidated:
      "您通过充值或参加活动获得的奖励币请在有效期内使用完，过期将作废。",
		goldCoinsNotReceived: "如充值金币未及时到账，请退出应用再次进入查看。",
		rechargeAgreement   : "充值即已同意",
		protocol            : "《充值协议》",
		specialOffer        : "特价",
		extra               : "额外",
		unlockAll           : "自动解锁剧集",
		day                 : "天",
		subscribe           : "订阅",
		price               : "价格",
		goldMall            : "金币商城",
		balance             : "余额",
		unlock              : "解锁",
		episode             : "集",
		timeLimited         : "限时首充",
		time                : "限时",
		otherOptions        : "其他选择",
		luckyUser           : "恭喜您被选为幸运用户，最优惠折扣套餐",
		HH                  : "时",
		MM                  : "分",
		SS                  : "秒",
		payNow              : "现在支付",
		unlockWeek          : "一周内解锁所有系列",
		unlockMonth         : "一月内解锁所有系列",
		unlockYear          : "一年内解锁所有系列",
		renew               : "续订",
		next                : "下一步",
		newUser             : "新用户奖励",
		only                : "仅剩",
		left                : "",
		monthly             : "月",
		annual              : "年",
		weekly              : "周",
		firstWeek           : "首周"
	},
	home: {
		loading        : "数据加载中...",
		all            : "共",
		ep             : "集",
		classification : "分类",
		recentlywatched: "观看过",
		collection     : "收藏",
		language       : "语言",
		logOut         : "退出登录",
		refresh        : "刷新",
		login          : "登录"
	},
	otherpage: {
		otherpage1: "充值金币后,金币迟迟不到账",
		otherpage2:
      "会因为网络原因延迟到账,这种情况需要等到网络良好后到充值页面即可到账,如果还是不行3天后会收到谷歌或者苹果的退款。",
		otherpage3:
      "如果金币未及时到账，可能由于网络繁忙原因到账延迟请不用担心，系统重新核实，一般在第二个工作日晚上18:00自动到账，如果因其他原因导致金币仍未到账，三个工作日金额会退回原支付账户。",
		otherpage4    : "问题反馈",
		inviteFriends1: "邀请观看",
		inviteFriends2: "进入ReelBuzz后完成一集观看，好友即可获得BOINS奖励",
		inviteFriends3: "提示：",
		inviteFriends4: "下载",
		inviteFriends5: "热门好剧",
		inviteFriends6: "邀请好友",
		inviteFriends7: "不可重复订阅",
		jelaskan1     :
      "订阅说明：\n• 会员购买：购买期为30天 、365天、7天。购买价格取决于产品。\n• 订阅续费：Google Pay账户将在到期日期前24小时收取费用，支付成功后订阅器将延长一个周期。订阅服务会持续到取消订阅为止。\n• 取消订阅：转到Google Pay-订阅-选择Reelbuzz以取消订阅。 \n• 会员服务一经启用，恕不退款，亦不适用无理由退货政策。。\n• 如果你对会员服务有任何疑问，点击我的-问题反馈，进入反馈页面与我们联系，我们的客服人员将会为您处理您的问题。",
		questionnaire: "问卷调查"
	},
	whatsapp: {
		paling           : "最热门",
		countDown        : "倒计时",
		extra            : "额外",
		rules            : "活动规则",
		eventDuration    : "活动时间：此充值折扣活动有效期为24小时。",
		eventDuration2   : "活参与方式：用户通过活动页面进行充值，可获得额外奖励。",
		eventDuration3   : "参与限制：每位用户只有一次参与机会，并且只能选择两个充值选项",
		rechargeAgreement: "充值即代表同意《充值协议》",
		exclusive        : "专属活动",
		event            : "活动"
	},
	prizeDraw: {
		ruleTip         : "活动规则",
		rules1          : "1.活动期间，首页显示活动入口弹窗，以及挂件，用户进入活动页面 。",
		rules2          : "2. 通过本次促销成功订阅的用户将自动启用订阅续订功能。",
		rules3          : "3. 订阅期间，用户可以无限观看所有剧集。",
		rules4          : "4. 同时订阅成功后自动报名参与手机抽奖活动，活动结束后可查看您的中奖结果。",
		rules5          : "5. 购买后，用户可随时取消订阅。在当前订阅期结束前的 24 小时，您的账户将自动续订并扣除费用。",
		rules6          : "6. 如有任何问题，请通过联系客户服务：个人资料 - 客户服务。",
		rules7          : "7. Reelbuzz 对本次促销活动拥有最终解释权。",
		stepsTip        : "参与手机抽奖",
		step1           : "第一步：成为会员自动报名活动~",
		step2           : "第二步：活动结束等待抽奖结果公示",
		step3           : "第三步：查看中奖结果公示",
		step4           : "第四步：如抽中奖品预留联系方式工作人员将与您取得联系",
		nubiaPhonetip   : "开斋节来临之际，为了感谢您对reelbuzz的支持我们将送出一批奖品，点击报名按钮参与抽奖活动，您将有机会获得新款手机",
		prizeInformation: "奖品信息",
		signup          : "报名",
		sorry           : "很抱歉",
		activityOver    : "活动已结束",
		congratulation  : "恭喜中奖",
		sorryForNotYou  : "很遗憾您未抽中奖品",
		uncommitted     : "你未参与本次活动",
		name            : "姓名 ",
		phone           : "手机号码",
		getcode         : "获取验证码",
		code            : "短信验证码",
		vipUser         : "会员",
		firstWeek       : "首周",
		everyWeek       : "每周",
		originWeek      : "之后每周",
		allFree         : "所有剧集可以免费观看",
		joinPrize       : "参与手机抽奖",
		priceDown       : "降价",
		Register        : "报名抽奖",
		dearVip         : "尊敬的会员",
		signupSuccess   : "报名成功",
		waitResult      : "请等待结果公告",
		connectWay      : "预留联系方式",
		hasconnectWay   : "已预留联系方式",
		usernickName    : "用户昵称",
		prize           : "奖品",
		pleaseName      : "请填写姓名",
		pleaseCode      : "请填写验证码",
		pleasePhone     : "请填写手机号",
		subSuccess      : "提交成功",
		submit          : "确认",
		cancleTip       : "自动续订随时取消",
		phoneName       : "手机"
	},
	inviteActivity: {
		startInvite   : "开始邀请好友",
		invite        : "邀请好友",
		couponNumber  : "抽奖券数量",
		getIcons      : "获得奖励币",
		activityTitle : "奖励活动",
		titleStep1    : "解锁短剧",
		titleStep2    : "用户深度观看短剧",
		titleStep3    : "用户充值",
		activityStep  : "如何邀请好友",
		step1         : "第一步：点击邀请好友",
		step2         : "第二步：将链接分享给好友，或发布到facebook",
		step3         : "第三步：好友下载ReelBuzz,并观看短剧",
		step4         : "第四步：获得奖励币,以及手机抽奖券",
		step5         : "第五步：等待抽奖结果",
		activityRank  : "邀请好友排名",
		rank          : "排名",
		userName      : "昵称",
		inviteCount   : "获得奖励",
		copyLink      : "复制URL",
		stepText1     : "第一步",
		stepText2     : "第二步",
		stepcontent1  : "点击下载",
		stepcontent2  : "打开应用并访问活动邀请好友活动页面",
		nowGet        : "现在获取",
		getDownnowload: "现在下载立即获得",
		direc         : "这是我认为最棒的印尼本地短剧app，这个app用拥有最多的印尼本地短剧，你可以下载这个app，来感受一下短剧的魅力，现在下载！",
		userNick      : "邀请用户昵称",
		congradulate  : "恭喜",
		asinviter     : "作为被邀请用户",
		youget        : "你获得了",
		getNow        : "现在领取",
		mostIcons     : "最多可获得"
	},
	userCancellationAgreement: {
		details : "账户删除是",
		details2: "不可恢复的操作。",
		details3: "在继续之前，请确保您已备份所有与您的账户相关的信息，并确保所有相关服务已得到妥善处理。后续注册将仅创建一个新账户。一旦您的账户被删除，您将无法再次使用该账户，也无法恢复与该账户相关的任何信息、内容、数据或服务(即使您使用相同的手机、电子邮件地址或其他凭证重新注册)在Reelbuzz平台上，包括但不限于:",
		details4: "1.账户下的资产将被清除删除账户时，您自愿放弃与账户相关的所有资产和权利，包括金币、奖励、优惠券、积分等其他资产。",
		details5: "建议您在删除账户前，使用完所有资产并妥善处理与账户相关的资产问题。如果您使用Google Pay或ApplePay，请务必查看您的订阅状态并确保取消自动续订。若未能取消自动续订，Google或Apple可能会继续根据您与其之间的协议向您收取订阅费用。关于订阅费用的争议或退款请求，请直接联系Google或Apple。",
		details6: "2.所有账户数据将被删除或匿名化您的个人资料信息和使用信息将被删除或匿名化，且无法恢复，包括但不限于用户名、电子邮件地址、密码、个人头像、书架记录、购买历史、充值记录、用于登录的第三方账户以及您所添加的任何内容或信息(包括免费内容和付费内容)。如果有任何您当前需要或预计会需要的特定内容或信息，请务必在删除账户之前保存相关内容或信息的副本。",
		details7: "3.账户删除不影响您与Reelbuzz之间的任何已执行协议如果您与Reelbuzz签订了任何协议，该协议将继续有效，各方应按照协议中的条款履行义务。例如，已授权的作品不会在协议到期之前被删除或下架。详细信息请联系我们:",
		details8: "如果您的账户被其他用户举报，正在被执法机关调查，正在进行诉讼或仲裁，或Reelbuzz认为(以其单方和绝对裁量权)账户存在被盗或被封锁的风险(“终止问题”)，Reelbuzz有权终止删除过程，无需通知您。在您申请删除账户后，您将有30天的时间来改变主意并取消删除。如果在此期间一切顺利且没有“终止问题”，您的信息可能需要最多120天才能完全删除或匿名化。当您删除账户时，我们将尽最大努力删除与您的账户相关的所有个人数据。然而，出于财务报告目的，我们必须保留过去的交易信息，并可能需要保留某些信息以遵守法院和其他法律程序的要求。我们还会保留已删除账户的记录，以符合法律义务，并在账户安全的合法利益需要时保留。请注意，删除账户并不免除您在删除前对账户执行的任何操作的责任。",
		details9: "services@reelbuzztv.com。"
	},
	inviteDraw: {
		hasContactWay: "已预留联系方式",
		contactWay   : "预留联系方式",
		nickName     : "昵称",
		confirm      : "确定",
		name         : "姓名",
		rank         : "排名",
		getReward    : "获取奖励",
		youHasGot    : "您在本次活动中共获得",
		sorry        : "您未参与本次活动",
		phone        : "手机号码",
		getCode      : "获取验证码",
		code         : "短信验证码",
		rules1       : "1、活动期间参与本活动的用户通过邀请好友方式获得Bonus奖励，以及手机抽奖券；",
		rules2       : "2、活动结束后在所有持有抽奖券的用户中随机抽取5名用户获得nubia smartPhone ，持有抽奖券越多，中奖几率越大；",
		rules3       : "3、Bonus奖励会实时发放到用户的账户余额中;",
		rules4       : "4、排行榜按照获取奖励从高到底排序，如获取奖励相同，则按照获取完成时间排序;",
		rules5       : "5、如有任何问题，请联系客户服务：个人资料 - 客户服务;",
		rules6       : "6、 Reelbuzz 对本次促销活动拥有最终解释权。",
		totalGet     : "您在本次活动中共获得"
	},
	catGame: {
		saleSuccess      : "出售成功 Bnous+",
		thinkAgain       : "再想想",
		confirmSale      : "确认出售",
		saleTip          : "出售后不可撤回，猫咪将永久消失",
		saleNumber       : "出售数量",
		sale             : "出售",
		noThisCat        : "暂未获得该小猫~",
		inventory        : "库存",
		saleCat          : "出售猫咪",
		noMore           : "没有啦~",
		heHasNocat       : "他还没有小猫哦~",
		youcanPet        : "今天还能摸",
		youcanPetTime    : "次哦~",
		downReelBuzz     : "下载Reelbuzz",
		adoptCat         : "领养小猫~",
		petCat           : "摸摸小猫",
		adoptMycat       : "领养一只我的小猫~",
		catPending       : "猫球待开启~",
		addToGallery     : "收藏至小猫图鉴",
		addToBag         : "收入图鉴并卖出",
		notSell          : "暂时不卖",
		raisingCountdown : "养育倒计时",
		continueRaising  : "继续养育",
		congrats         : "恭喜,获得",
		open             : "开启",
		openCat          : "开启猫球",
		noRecords        : "暂无记录",
		tips             : "提示:",
		tipOne           : "每只小猫在孵化期间可以接受10次摸猫哦~",
		tipTwo           : "在养育期间可以接受15次摸猫哦~",
		tipThree         : "成功邀请 好友安装注册Reelbuzz会获得奖励币",
		pettedYourcat    : "摸了摸你的小猫",
		catLog           : "摸猫记录",
		others           : "其他",
		copyUrl          : "复制URL",
		copySuccess      : "复制成功",
		shareNow         : "立即分享",
		startPush        : "开启通知，接受孵化状态",
		notification     : "动态通知",
		shareFriendOne   : "分享好友",
		shareFriendTwo   : "摸摸小猫",
		acceptPush       : "接受通知",
		hatchingCountdown: "孵化中：",
		ruleOne          : "看完任意一部剧，都会获得猫球奥~",
		ruleTwo          : "当前有在孵化的小猫奥 ",
		ruleThree        : "从个人主页的观看记录处领取猫球",
		ruleFour         : "孵化和养育都需要一些时间，可以邀请好友帮忙摸猫加速~",
		ruleFive         : "历经孵化的成年猫，将进入收藏图鉴",
		ruleSix          : "二次获得成年猫可以在背包中进行售出操作",
		startHatching    : "开始孵化",
		catBall          : "猫球",
		catHouse         : "猫窝",
		// catGallery       : "小猫图鉴",
		// myBag            : "我的猫包",
		// catchRaising     : "养猫手册",
		catGallery       : "Galeri Anak Kucing",
		myBag            : "Tas Kucingku",
		catchRaising     : "Panduan Kucing",
		goHome           : "回家",
		selectCat        : "选择一只猫球",
		raisingSuccess   : "养育成功",
		rasing           : "养育中：",
		waitOpen         : "待开启",
		hatching         : "孵化中：",
		hatchingSuccess  : "孵化成功:",
		freeTime         : "空闲中",
		confirm          : "确认",
		pleaseEnterName  : "请输入昵称",
		nickName         : "昵称",
		putAway          : "收起来吧~",
		startRaising     : "开始养猫",
		yayGot           : "耶，得到了猫球 ",
		claimCatball     : "领猫球",
		viewingHistory   : "已看记录",
		square           : "广场",
		home             : "个人主页",
		myCat            : "我的小猫",
		raisingCat       : "养一只小猫",
		nocatYey         : " 还没有获得小猫，快去领养一只~",
		grown            : "成长加速",
		dramaCommend     : "短剧推荐",
		watchEpisodes    : "观看剧集",
		Raise            : "养育",
		Hatch            : "孵化",
		redeemRewards    : " 兑换奖励",
		welcomeTo           : "欢迎来到",
		ofCatHouse          : "的猫窝",
		goToSquare          : "去广场",
		hatchComplete       : "孵化完成",
		hatchCompleteTip    : "小猫已经孵化完成快来看看吧~",
		petSpeedTip         : "被爱抚可加速一小时成长，最多十次",
		petToSpeedHatch     : "小猫正在孵化中，摸摸他可以帮他加速",
		maxPetTimes         : "每只小猫最多可以接受10次爱抚",
		someoneHelped       : "已帮你加速",
		helpedOneHour       : "已加速了1小时",
		hasLiked            : "已点赞",
		like                : "点赞",
		setFavorite         : "设置最爱",
		catRanking          : "排行榜",
		viewProfile         : "查看主页",
		rankingUpdateTip    : "每天00:00更新",
		raiseCats           : "养猫",
		catUnit             : "只",
		selectMonth         : "选择月份",
		dramaLovingCat      : "沉迷追剧的喵星人~",
		clickTap            : "点击",
		giveLike            : "给他一个赞吧",
		favoriteDrama       : "最爱剧目",
		change              : "更换",
		watch               : "观看",
		noFavoriteDramaClick: "暂无最爱的短剧，点击选择",
		noFavoriteDrama     : "暂无最爱的短剧",
		bio                 : "个人简介",
		male                : "男",
		female              : "女",
		likeHistory         : "点赞记录",
		likedYou            : "给你点赞了",
		noLikeHistory       : "暂无点赞记录",
		operationFailed     : "操作失败"
	},
	yearlyReport: {
		title        : "欢迎来到2025年度观影报告",
		startReport  : "开启我的回忆",
		iAgree       : "我已阅读并同意",
		yearlyReport : "年度报告授权协议",
		firstTime    : "你第一次登录Reelbuzz的时间是",
		firstDate    : "距离第一次登录",
		hasPast      : "已经过去",
		day          : "天",
		thenYouwatch : "之后，你观看了",
		topContinue  : "上划继续",
		morning      : "上午",
		afternoon    : "下午",
		night        : "夜晚",
		linchen      : "凌晨",
		earlyTime    : "你最早一次看剧是在",
		latestTime   : "你最晚一次看剧是在",
		hopeDate     : "希望每个忙碌的日间，都有故事相伴",
		hopeNight    : "希望每个寂静的深夜，都有故事相伴",
		thisYear     : "这一年",
		youWatch     : "你共观看了",
		episodes     : "部剧",
		pass         : "超过了",
		users        : "用户",
		youFavorite  : "你最喜欢的类型为",
		youloveIsBest: "你热爱的就是最好的！",
		loveActors   : "你最喜欢看他们演的剧",
		suprice      : "我们为你准备了专属惊喜",
		aLetterFrom  : "一封来自",
		and          : "和",
		letter       : "的信",
		content      : "感谢你的喜爱与支持，愿我们未来都所有收获，祝你新的一年，天天开心",
		reportYear   : "2025年度观影报告",
		shortStory   : "有些故事很短",
		youStop      : "但你愿意停下来",
		thanksWatch  : "感谢谢你的每一次观看",
		seeAgain     : "再看一遍",
		share        : "立即分享",
		maybe        : "也许你还没有",
		likeactors   : "喜欢的演员",
		butlike      : "但喜欢，正在发生...",
		openLetter   : "点击下方信件拆开",
		all          : "相伴",
		allWatch     : "共观看",
		cancle       : "取消",
		argee        : "同意",
		confirm      : "确认",
		noProtocol   : "暂无观影记录",
		document     : "Saya menyetujui dan memberikan izin kepada platform, sesuai dengan ketentuan hukum yang berlaku, untuk menggunakan riwayat tontonan dan data interaksi saya di dalam platform guna menghasilkan dan menampilkan laporan tahunan pribadi. Informasi tersebut hanya digunakan untuk keperluan laporan tahunan, dan platform akan mengambil langkah-langkah yang wajar sesuai hukum untuk melindungi keamanan data pengguna serta tidak akan mengungkapkan informasi yang dapat mengidentifikasi identitas pribadi kepada pihak ketiga tanpa izin."
	},
	valentineDay: {
		notExpired        : "未到期",
		completed         : "已完成",
		go                : "去完成",
		exchange          : "兑换奖励",
		exchanged         : "已兑换",
		exchangeCount     : "兑换次数",
		taskType1         : "每日登录",
		taskType2         : "情人节当天登录",
		taskType3         : "看剧时间累计超过",
		taskType4         : "观看视频广告",
		taskType5         : "观看完一整部剧",
		taskType6         : "订阅会员",
		taskType7         : "观看",
		taskType8         : "邀请一名新用户注册",
		taskType9         : "分享好友",
		taskType10        : "情人节当天登录",
		heartValue        : "心动值",
		rule              : "规则",
		shareTitle        : "分享好友获得奖励机会",
		headFrame         : "头像框",
		coin              : "奖励币",
		receiveReward     : "领取奖励",
		valentinaHeadFrame: "情人节限定头像框",
		hadSeen           : "已观看",
		pushMe            : "提醒我",
		changeTimes       : "兑换次数",
		got               : "获得",
		day               : "天",
		detail            : "明细",
		income            : "收入",
		expenditure       : "支出",
		noData            : "暂无明细",
		gotoActivity      : "前往活动",
		pleaseUpgrade     : "请将客户端版本升级至最新版本",
		minute            : "分钟",
		over              : "已结束",
		activityOver      : "活动已结束",
		seeName           : "观看《弟弟班主任是我初恋》",
		countTime         : "倒计时",
		dayilyTask        : "每日任务",
		specialTask       : "特别任务",
		eventRewards      : "活动奖励",
		notRelease        : "该剧暂未上映",
		rulesContent      : "活动时间：2026 年 2 月 4 日 00:00 – 2 月 19 日 23:59。活动期间，完成每日任务及指定活动任务即可获得「心动值」。心动值可用于兑换 VIP 会员、情人节限定头像框及 Bonus 奖励。活动结束后，未使用的心动值将清零，请及时兑换。活动规则及奖励以页面展示为准。 翻译多种语言"
	},
	caimH5: {
		onlyleft          : "仅差最后",
		canGet            : "即可提现",
		hasGot            : "已获得金额",
		//待获得金额
		pendingGet        : "待获得金额",
		//距离
		distance          : "距离",
		onlyDiamond       : "仅差钻石",
		pendingDiamond    : "待获得钻石",
		rules             : "规则",
		rewordsList       : "奖品纪录",
		inviteFriends     : "邀请好友",
		getRewards        : "获得",
		drawChance        : "次抽奖机会",
		chance            : "机会",
		//助力记录
		helpRecord        : "助力记录",
		close             : "关闭",
		//再送您
		againSendYou      : "再送您",
		justInvite        : "只需要邀请",
		oneFriend         : "一个朋友",
		register          : "注册",
		//太棒啦，获得
		great             : "太棒啦，获得",
		//谢谢惠顾
		thanksForVisiting : "谢谢惠顾",
		shareTitle        : "分享好友获得奖励机会",
		//点击
		clickToDownload   : "点击下载Reelbuzz",
		downLoadandEnter  : "下载Reelbuzz并进入",
		clickToParticipate: "点击参与活动",
		enterReelbuzz     : "进入Reelbuzz参与提现活动",
		getMoney          : "获得现金奖励",
		getMoneyNow       : "完成活动条件并获得现金奖励"
	},
  sacrifice: {
    tomorrowOpen: '明天再来',
    immediatelyReserve: '立即预约',
    reserveSuccess: '已预约',
    immediatelyWatch: '立即观看',
    indonesianOriginal: '本地',
  },
};
